import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const ErrorSummary = ({fields}) => {
    const {formState: { errors }} = useFormContext();
    if(!fields){
        fields = [];
        Object.keys(errors).map((key) => {
            console.log(key);
            var lbl = key.replace(/([A-Z])/g, " $1");
            const label = lbl.charAt(0).toUpperCase() + lbl.slice(1);
            fields.push({label: label, name: key})
        });
    }
    return ( <>
            {fields && fields.length > 0 ?
            <div className="bg-red-50 p-4 my-4">
                <div className="pb-2"> 
                    <strong>Please correct the following issues to continue:</strong>
                </div>
              
              <ul className="list-disc ml-8">
                {
                  fields.map((field, key) => 
                    <li key={key} className='py-1'>
                        <ErrorMessage errors={errors} name={field.name} render={({message}) => 
                        <>
                            {field.label}: {message}
                        </>}
                        />
                    </li>
                 )
                }
              </ul>
            </div>
            : <></>}
    </> );
}
 
export default ErrorSummary;